import {
    RECEIVER_SUCCESS,
    RECEIVER_FAILED,
    RECEIVER_NOT_FOUND,
    RECEIVER_INVALID_TOKEN,
    RECEIVER_WALLET_OWNER_ID,
    LOADING_RECEIVER,
    RESET_RECEIVER
} from "../types";


const initialState = {
    isLoading: false,
    notFound: false,
    failed: false,
    invalidToken: false,
    success: false,
    invalidWalletOwnerId: false,
    data: {},
    userList: [],
    status: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_RECEIVER:
            return {
                ...state,
                isLoading: true,
                notFound: false,
                failed: false,
                invalidToken: false,
                success: false,
                invalidWalletOwnerId: false,
                data: {},
                status: ""
            };
        case RECEIVER_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                notFound: true,
                failed: false,
                invalidToken: false,
                success: false,
                invalidWalletOwnerId: false,
                data: {},
                userList: [],
                status: "Receiver Not Found"
            };
        case RECEIVER_FAILED:
            return {
                ...state,
                isLoading: false,
                notFound: false,
                failed: true,
                invalidToken: false,
                success: false,
                invalidWalletOwnerId: false,
                data: {},
                userList: [],
                status: "Failed"
            };
        case RECEIVER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                notFound: false,
                failed: false,
                invalidToken: false,
                success: true,
                invalidWalletOwnerId: false,
                data: action.payload,
                userList: [].concat(action.payload.userList),
                status: ""
            };
        case RECEIVER_WALLET_OWNER_ID:
            return {
                ...state,
                isLoading: false,
                notFound: false,
                failed: false,
                invalidToken: false,
                success: false,
                invalidWalletOwnerId: true,
                data: {},
                userList: [],
                status: "Invalid Wallet Owner"
            };
        case RECEIVER_INVALID_TOKEN:
            return {
                ...state,
                isLoading: false,
                notFound: false,
                failed: false,
                invalidToken: true,
                success: false,
                invalidWalletOwnerId: false,
                data: {},
                userList: [],
                status: "Invalid Token"
            };

        case RESET_RECEIVER:
            return (state = initialState);

        default:
            return state;
    }
};